<template lang="html">
  <section class="news">
    <div class="row">
      <div id='loadingmessage' style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;" v-if="loading">
          <p style="position: absolute; color: White; top: 40%; left: 40%;">
            <img src='../../assets/snakes.gif' /></p>
      </div>
       <div class="col-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                 <h4 class="card-title"><b>Location:</b> {{items.where}}</h4>
            </div>
            <div class="col-md-4">
             <b>Time of Incident:</b> {{items.timeofincident}}
            </div>
           <div class="col-md-4" v-if="items != ''">
             <b>Added By:</b> {{items.added_by.email}}
            </div>
            <div class="big4" v-if="items != ''">
             <img v-bind:src="'https://sarpatnapi.leopardtechlabs.in/u/'+items.photo" width="100%" height="auto">
            </div>
             </div>
             </div>
             </div>
             </div>
    </div>
  </section>
</template>
<script lang="js">
import axios from 'axios'
import { VueEditor } from 'vue2-editor'
import vSelect from 'vue-select'
export default {
  name: 'news',
  props: ['id'],
  components: {
    VueEditor,
    vSelect
  },
  data () {
    return {
      items: '',
      name: '',
      venomType: '',
      reply: '',
      description: '',
      snakes: [],
      loading: false
    }
  },
  mounted: function () {
    this.getAll()
  },
  methods: {
    getAll () {
      this.loading = true
      axios({
        url: 'https://sarpatnapi.leopardtechlabs.in/adminreply/',
        method: 'GET',
        params: {
          id: this.id
        },
        headers: {
                    'x-auth-token': localStorage.getItem("token")
                },
      }).then(response => {
        this.items = response.data.data
        this.loading = false
      }).catch(e => {
        this.loading = false
      })
    },
  }
}
</script>
<style scoped lang="scss">
#preview {
  display: flex;
  justify-content: center;
  align-items: center;
}

#preview img {
  width: 20%;
}
</style>


// WEBPACK FOOTER //
// src/views/forms/identifyviewdetails.vue